import {
  useUserProfileresendEmailVerification,
  useUserProfileuserinfoQuery
} from "@/lib/api/requests/user-profile.requests";
import { Button } from "@/ui-components/ui/button";
import { Card, CardContent } from "@/ui-components/ui/card";
import { Loader2, Mail, RefreshCw, Shield } from "lucide-react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "@/lib/toast";

const MailVerification = () => {
  let [searchParams] = useSearchParams();
  const mail = searchParams.get("mail");
  const resendEmailVerificationMutation = useUserProfileresendEmailVerification();
  const { data: userInfo } = useUserProfileuserinfoQuery({
    retry: false,
    refetchOnWindowFocus: false,
  });

  const [isResending, setIsResending] = useState(false);

  if (userInfo && Object.keys(userInfo).length !== 0) {
    window.location.href = "/";
  }

  const resendMail = async () => {
    setIsResending(true);
    resendEmailVerificationMutation.mutate(undefined, {
      onSuccess: () => {
        toast.success("Bestätigungs-E-Mail wurde erneut gesendet.");
        setIsResending(false);
      },
      onError: (error) => {
        toast.error("E-Mail konnte nicht gesendet werden", {
          description: "Bitte später erneut versuchen.",
          error,
        });
        setIsResending(false);
      },
    });
  };

  const reloadStatus = async () => {
    window.location.reload();
  };

  return (
    <div className="h-screen w-full bg-slate-50/30 flex flex-col items-center py-12 px-4 sm:px-8 overflow-y-auto">
      <div className="w-full max-w-lg space-y-10 animate-in fade-in duration-700 slide-in-from-bottom-4">
        
        {/* Header Logo */}
        <div className="flex flex-col items-center gap-6">
           <img src="/logo.png" alt="SportyPost Logo" className="h-10 md:h-12 object-contain opacity-80" />
        </div>

        <Card className="border-none shadow-xl shadow-slate-200/40 bg-white ring-1 ring-slate-200/60 rounded-2xl overflow-hidden">
            <CardContent className="p-0">
              <div className="p-8 md:p-10 space-y-8">
                
                <div className="flex items-start gap-4 pb-6 border-b border-slate-100">
                  <div className="p-3 bg-blue-50 rounded-xl text-blue-600 shrink-0">
                    <Mail className="w-6 h-6" />
                  </div>
                  <div className="space-y-1">
                    <h2 className="text-xl font-semibold text-slate-900">E-Mail bestätigen</h2>
                    <p className="text-slate-500 text-sm">{`Eine E-Mail wurde an ${mail ?? "Ihre Adresse"} gesendet.`}</p>
                  </div>
                </div>
                
                <p className="text-slate-500 text-sm leading-relaxed text-left">
                  Um Zugriff auf alle Funktionen zu erhalten, bestätigen Sie bitte Ihre E-Mail-Adresse. 
                  Überprüfen Sie Ihren Posteingang und klicken Sie auf den Bestätigungslink. 
                  Schauen Sie bitte auch in Ihrem Spam-Ordner nach.
                </p>

                <div className="space-y-3 pt-4">
                  <Button 
                    onClick={resendMail} 
                    disabled={isResending}
                    className="w-full h-11 text-base font-medium shadow-lg shadow-blue-500/25 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all hover:scale-[1.02] active:scale-[0.98]"
                  >
                    {isResending ? (
                      <>
                        <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                        Sende E-Mail...
                      </>
                    ) : (
                      "E-Mail erneut senden"
                    )}
                  </Button>
                  
                  <Button 
                    variant="outline" 
                    onClick={reloadStatus}
                    className="w-full h-11 text-base font-medium border-slate-200 hover:bg-slate-50 hover:text-slate-900 rounded-xl transition-colors"
                  >
                    <RefreshCw className="mr-2 h-4 w-4" />
                    Seite aktualisieren
                  </Button>
                </div>

              </div>
            </CardContent>
          </Card>
          
          <div className="mt-8 flex justify-center gap-6 opacity-60 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">
             <div className="flex flex-col items-center gap-2">
               <Shield className="w-5 h-5 text-slate-400" />
               <span>Sicherer Login</span>
             </div>
          </div>

      </div>
    </div>
  );
};

export default MailVerification;
